import React, { useEffect, useState } from "react";
import { ReactComponent as ArrowDown } from "../../images/YuJa_arrow_down_icon.svg";
import { ReactComponent as ArrowUp } from "../../images/YuJa_arrow_up_icon.svg";
import {DROPDOWN_TEXT, TRY_ANOTHER_SEARCH_TEXT, YUJA_DROPDOWN_SIZE} from "../../utils/constants";
import styles from "./YuJaDropdown.module.css";
import { YuJaTooltip } from "./YuJaTooltip";
import {findFirstOverflowParent, generateUUID} from "../../utils/helpers";
import {ReactComponent as SearchIcon} from "../../images/search_bar_icon.svg";
import {ReactComponent as ERROR} from "../../images/cross_cricle_red.svg"
import PropTypes from "prop-types";
import useWindowDimensions from "../../hooks/useWindowDimensions";

export const YuJaDropdown = ({
                                 data=[], onChange, onOpen=() => {}, onClose=() => {}, onOptionHover,
                                 ariaLabel, isInvalid=false, errorMsg="",
                                 name, arrowSize=null, value, placeholder, getOptionLabel, getOptionValue, getOptionIcon, searchPlaceholder="Search...",
                                 containerStyle={}, style={}, textStyle={}, listStyle={}, itemStyle={},
                                 searchAble=false, size=YUJA_DROPDOWN_SIZE.MEDIUM, presenterIcon, customPresenter,
                                 upIcon, downIcon, limitedSpace=true,
                                 ...props
}) => {
    const [randomId, ] = useState(() => generateUUID());
    let UP_ICON = upIcon;
    let DOWN_ICON = downIcon;

    const windowDimensions = useWindowDimensions();
    const [isOpen, setIsOpen] = useState(props?.defaultOpen || false);
    const smallMenuHeight = 200;
    const bigMenuHeight = 230;
    const [maxMenuHeight, setMaxMenuHeight] = useState(bigMenuHeight);
    const [menuVisible, setMenuVisible] = useState(false);
    const [searchKeywords, setSearchKeywords] = useState("");
    const [reversed, setReversed] = useState(false);

    let sizeClassName;
    if (size === YUJA_DROPDOWN_SIZE.SMALL) {
        sizeClassName = styles.small;
    } else if (size === YUJA_DROPDOWN_SIZE.MEDIUM) {
        sizeClassName = styles.medium;
    } else {
        sizeClassName = styles.large;
    }

    const open = () => {
        if (props.disabled) {
            return;
        }
        setIsOpen(!isOpen);
        if (props?.setOpen) {
            props.setOpen(!isOpen);
        }
    }

    const onClick = (item) => {
        setIsOpen(false);
        if (props.disabled) {
            return;
        }

        if (props?.setOpen) {
            props.setOpen(false);
        }
        const input = document.querySelector(`[data-yuja-dropwdown-input-id='${randomId}']`);
        if (input) {
            input.value = item.value;
        }
        if (onChange) {
            onChange(item);
        }


        const parent = document.querySelector(`[data-yuja-dropdown-parent-id='${randomId}']`);
        let comboBox = parent.querySelector("[role='combobox']");
        if (!!comboBox) {
            comboBox.focus();
        }

    }

    const getLabel =(item) => {
        if (!item) {
            return "";
        }
        if (getOptionLabel) {
            return getOptionLabel(item);
        }

        return item.label;
    }

    const getValue =(item) => {
        if (!item) {
            return "";
        }
        if (getOptionValue) {
            return getOptionValue(item);
        }

        return item.value;
    }

    useEffect(() => {
        if (props?.defaultOpen) {
            setIsOpen(true);
            if (props?.setOpen) {
                props.setOpen(true);
            }
        }
    }, []);

    useEffect(() => {
        if (!isOpen) {
            onClose();
            return;
        }
        let menu = document.querySelector(`[data-yuja-dropdown-menu-id='${randomId}']`);

        for (const node of menu?.children) {
            const textNode = node?.children?.length ? node.children[0] : null;
            if (textNode && textNode.offsetWidth < textNode.scrollWidth) {
                textNode.title = textNode.innerText;
            }
        }
        onOpen();
    }, [isOpen]);


    const keywordsFilter = (item) => {
        if (!searchAble || !searchKeywords || searchKeywords.trim().length === 0) {
            return true;
        }
        let label = getLabel(item).toLowerCase();

        return label.includes(searchKeywords.trim().toLowerCase());
    }



    function isVisible (parent, child) {
        let {top: childTop, height: childHeight} = child.getBoundingClientRect();
        let {top: parentTop, height: parentHeight} = parent.getBoundingClientRect();

        return !(childTop + childHeight < parentTop || childTop > parentTop + parentHeight);

    }

    const setPosition = () => {
        let dropdownPresenter = document.querySelector(`[data-dropdown-presenter-id='${randomId}']`);
        let menu = document.querySelector(`[data-yuja-dropdown-menu-id='${randomId}']`);

        if (!dropdownPresenter || !menu) {
            return;
        }

        let parent = findFirstOverflowParent(dropdownPresenter);
        if (!isVisible(parent, dropdownPresenter)) {
            setMenuVisible(false);
        } else {
            setMenuVisible(true);
        }



        const {left, width, height, top, } = dropdownPresenter.getBoundingClientRect();
        const {height: menuHeight} = menu.getBoundingClientRect();
        menu.style.width = `${width}px`;


        let caseDownHeight = window.innerHeight - top - height - 5;
        let caseUpHeight = top - 5;
        if (caseDownHeight >= menuHeight) {
            setReversed(false);
            menu.style.transform =  `translate(${Math.round(left)}px, ${Math.round(top + height + 5) - 1}px)`;
        } else if (caseUpHeight >= menuHeight) {
            setReversed(true);
            menu.style.transform =  `translate(${Math.round(left)}px, ${Math.round(top - menuHeight - 5)}px)`;
        } else {

            if (caseDownHeight > bigMenuHeight || caseDownHeight > caseUpHeight) {
                setMaxMenuHeight(caseDownHeight);
                setReversed(false);
                menu.style.transform =  `translate(${Math.round(left)}px, ${Math.round(top + height + 5)}px)`;
            } else {
                setMaxMenuHeight(caseUpHeight);
                setReversed(true);
                menu.style.transform =  `translate(${Math.round(left)}px, 0)`;
            }
        }

    }

    useEffect(() => {
        if (isOpen) {
            document.addEventListener('scroll', setPosition, true);
            setPosition();
        }

        return () => {
            document.removeEventListener('scroll', setPosition)
        };
    }, [isOpen, windowDimensions, randomId]);

    useEffect(() => {

        if (!searchAble || !reversed || !isOpen) {
            return;
        }

        let dropdownPresenter = document.querySelector(`[data-dropdown-presenter-id='${randomId}']`);
        let menu = document.querySelector(`[data-yuja-dropdown-menu-id='${randomId}']`);

        if (!dropdownPresenter || !menu) {
            return;
        }

        const {left, top, } = dropdownPresenter.getBoundingClientRect();
        const {height: menuHeight} = menu.getBoundingClientRect();
        menu.style.transform =  `translate(${Math.round(left)}px, ${Math.round(top - menuHeight - 5)}px)`;

    }, [searchKeywords]);


    useEffect(() => {
        const handleKeyDownDropdown = (event) => {
            const parent = document.querySelector(`[data-yuja-dropdown-parent-id='${randomId}']`);
            if (event.key === 'Tab' || event.key === 'Escape') {
                let comboBox = parent.querySelector("[role='combobox']");
                if (!!comboBox) {
                    comboBox.focus();
                }
                setIsOpen(false);
                event.preventDefault();
                return;
            }

            if (event.key !== "ArrowUp" && event.key !== "ArrowDown") {
                // event.preventDefault();
                // data-yuja-dropwdown-input-id
                let activeElement = document.activeElement;
                let isInput = activeElement.hasAttribute("data-yuja-dropwdown-search-input-id")
                && activeElement === document.querySelector(`[data-yuja-dropwdown-search-input-id='${randomId}']`);
                if (!isInput) {
                    event.preventDefault();
                }
                return;
            }

            const container = document.querySelector(`[data-yuja-dropdown-menu-id='${randomId}']`);
            if (!container) {
                return;
            }

            const focusableElements = container.querySelectorAll('[data-navigate-able-dropdown-item]');

            if (!container.contains(event.target)) {
                event.preventDefault();
                let selectedOption = container.querySelector("[role='listbox'] [aria-selected='true']");
                if (!!selectedOption) {
                    selectedOption.focus();
                } else if (focusableElements.length > 0) {
                    focusableElements[0].focus();
                }

                return;
            }

            if (event.key === "ArrowUp") {
                for (let i = 0; i < focusableElements.length; i++) {
                    if (focusableElements[i] !== event.target) {
                        continue;
                    }
                    if (i === 0) {
                        event.preventDefault();
                        focusableElements[focusableElements.length - 1].focus();
                        let listBox = container.querySelector("[role='listbox']");
                        if (!!listBox) {
                            listBox.scrollTop = listBox.scrollHeight;
                        }
                        return;
                    } else {
                        event.preventDefault();
                        focusableElements[i - 1].focus();

                        return;
                    }
                }
            } else {
                for (let i = 0; i < focusableElements.length; i++) {
                    if (focusableElements[i] !== event.target) {
                        continue;
                    }
                    if (i === focusableElements.length - 1) {
                        event.preventDefault();
                        focusableElements[0].focus();
                        let listBox = container.querySelector("[role='listbox']");
                        if (!!listBox) {
                            listBox.scrollTop = 0;
                        }
                        return;
                    } else {
                        event.preventDefault();
                        focusableElements[i + 1].focus();
                        return;
                    }
                }
            }

        };

        if (!!isOpen) {
            document.addEventListener("keydown", handleKeyDownDropdown);
            const container = document.querySelector(`[data-yuja-dropdown-menu-id='${randomId}']`);
            const observer = new MutationObserver((mutations, obs) => {
                obs.disconnect();
                document.dispatchEvent(new KeyboardEvent("keydown", {key: "ArrowDown"}))
            });
            observer.observe(container, {
                childList: false,
                attributes: true,
                subtree: false,
            });
        }


        return () => {
            document.removeEventListener("keydown", handleKeyDownDropdown);
        };
    }, [isOpen, randomId]);

    useEffect(() => {
        const handleGlobalClick = (event) => {
            let dropdownPresenter = document.querySelector(`[data-dropdown-presenter-id='${randomId}']`);
            let menu = document.querySelector(`[data-yuja-dropdown-menu-id='${randomId}']`);
            // Check if the click occurred outside of the dropdown
            if (isOpen && !!dropdownPresenter && !!menu
                && !dropdownPresenter.contains(event.target) && !menu.contains(event.target)
            ) {
                setIsOpen(false);
                if (props?.setOpen) {
                    props.setOpen(false);
                }
            }
        };

        if (isOpen) {
            document.addEventListener('click', handleGlobalClick, true);
            // addClickEventHandler(handleGlobalClick);
        } else {
            setMenuVisible(false);
            setSearchKeywords("");
        }

        return () => {
            document.removeEventListener('click', handleGlobalClick)
        };
    }, [isOpen, randomId]);

    return (
        <div
            data-yuja-dropdown-parent-id={randomId}
            className={styles.container}
            style={{
                ...containerStyle,
                marginBottom: isInvalid && errorMsg && !limitedSpace ? 26 : containerStyle.marginBottom
            }}
        >

            <YuJaTooltip
                text={value ? getLabel(data.find(item => getValue(item) === value)) : placeholder}
                placement={"bottom"}
                disabled={!placeholder || props.disabled}
            >
                <div
                    id={`yuja-dropdown-${randomId}-button`}
                    tabIndex={props.disabled ? -1 : 0}
                    className={`${styles.presenter} ${isOpen ? styles.active : ""} ${sizeClassName} ${isInvalid ? styles.invalid : ""} ${props.disabled ? styles.disabled : ""}`}
                    onClick={open}
                    style={{...style}}
                    aria-label={!!ariaLabel ? ariaLabel : DROPDOWN_TEXT}
                    // onKeyDown={(e) => handleTabDown(e)}
                    role="combobox"
                    aria-haspopup="listbox"
                    aria-expanded={!!isOpen ? "true" : "false"}
                    aria-controls={randomId}
                    data-dropdown-presenter-id={randomId}
                    aria-activedescendant={!!value ? `yuja-dropdown-${randomId}-option-${value}` : ""}
                >
                    {!!presenterIcon && <>{presenterIcon}</>}
                    {!!getOptionIcon && <>{getOptionIcon(data.find(item => getValue(item) === value))}</>}
                    <span className={`${styles.presenterText} ${value ? styles.selected : ""}`} style={{...textStyle}}>
                        {!!customPresenter
                            ? customPresenter()
                            : value ? getLabel(data.find(item => getValue(item) === value)) : placeholder
                        }
                    </span>
                    {!isOpen && (!!downIcon
                        ? <DOWN_ICON className={styles.arrowIcon} style={{width: "unset", height: "unset"}}/>
                        : <ArrowDown className={styles.arrowIcon}/>
                    )}
                    {isOpen && (!!upIcon
                        ? <UP_ICON className={styles.arrowIcon} style={{width: "unset", height: "unset"}}/>
                        : <ArrowUp className={styles.arrowIcon}/>
                    )}

                    {isInvalid && errorMsg && limitedSpace &&
                        <div className={styles.iconContainer}>
                            <YuJaTooltip placement={"right"} text={errorMsg}
                                         tooltipStyle={{maxWidth: 300, whiteSpace: "pre-wrap"}}>
                                <div className={styles.invalidIcon}/>
                            </YuJaTooltip>
                        </div>
                    }

                    {isInvalid && errorMsg && !limitedSpace &&
                        <div className={styles.normalErrorMsgContainer}>
                            <ERROR style={{flexShrink: 0}}/> <span>{errorMsg}</span>
                        </div>
                    }
                </div>
            </YuJaTooltip>

            <input
                data-yuja-dropwdown-input-id={randomId}
                defaultValue={value}
                name={name}
                style={{display: "none"}}
                id={value}
            />
            {/*{isOpen &&*/}
                <div
                    data-yuja-dropdown-menu-id={randomId}
                    className={styles.menuListContainer}
                    style={{
                        maxHeight: maxMenuHeight,
                        display: isOpen ? undefined : "none",
                        visibility: isOpen && menuVisible ? "visible" : "hidden",
                        flexDirection: reversed ? "column-reverse" : undefined
                    }}
                >
                    {searchAble &&
                        <div
                            className={`${styles.searchBar} ${sizeClassName}`}
                            style={reversed ? {borderBottomWidth: 0, borderTopWidth: 1} : {}}
                        >
                            <SearchIcon style={{flexShrink: 0}}/>
                            <input
                                data-navigate-able-dropdown-item={0}
                                data-yuja-dropwdown-search-input-id={randomId}
                                aria-label={searchPlaceholder}
                                tabIndex={-1}
                                value={searchKeywords}
                                onChange={e => setSearchKeywords(e.target.value)}
                                placeholder={searchPlaceholder}
                                style={{flex: 1, minWidth: 0}}
                            />
                        </div>
                    }

                    <ul
                        id={randomId}
                        role={"listbox"}
                        aria-labelledby={`yuja-dropdown-${randomId}-button`}
                        className={styles.menuList}
                        style={{...listStyle}}
                    >
                        {data.filter(keywordsFilter).map((item, idx) =>
                            <li
                                key={idx}
                                id={`yuja-dropdown-${randomId}-option-${value}`}
                                data-navigate-able-dropdown-item={idx + 1}
                                className={`${styles.menuItem} ${sizeClassName} ${getValue(item) === value ? styles.selected : ""}`}
                                style={{...itemStyle}}
                                onClick={() => onClick(item)}
                                onMouseEnter={() => !!onOptionHover ? onOptionHover(item) : {}}
                                tabIndex={-1}
                                role={"option"}
                                aria-selected={getValue(item) === value ? "true" : "false"}
                                title={getLabel(item)}
                            >
                                {!!getOptionIcon && <>{getOptionIcon(item)}</>}
                                <span className={styles.menuItemText}>{getLabel(item)}</span>
                            </li>
                        )}
                        {!data.filter(keywordsFilter).length && searchAble &&
                            <li
                                className={`${styles.menuItem} ${sizeClassName} ${styles.unselectable}`}
                                style={{...itemStyle}}
                                role={"option"}
                                aria-selected={"false"}
                            >
                                <span className={styles.menuItemText}>{TRY_ANOTHER_SEARCH_TEXT}</span>
                            </li>
                        }
                    </ul>
                </div>
            {/*}*/}
        </div>

    );
}
YuJaDropdown.propTypes = {
    size: PropTypes.oneOf(["small", "medium", "large"]),
}